import { useFormikContext } from "formik";
import { AppWindow } from "lucide-react";
import RegionField from "./RegionField";
import SectionForm from "./SectionForm";

export default function RegionSelector(props) {
    const {
        loadingProvinces,
        loadingCities,
        loadingDistricts,
        dataProvinces,
        dataCities,
        dataDistricts,
        setProvince,
        setCity,
        setDistrict,
        setDataCities,
        setDataDistricts,
    } = props;

    const { values, setFieldValue } = useFormikContext();

    const ministryShortName = {
        "Kemendikdasmen": "DISDIK",
        "Kementerian Agama": "KEMENAG",
        "Kementerian Sosial": "DINSOS",
        "Kementerian Dalam Negeri": "KEMENDAGRI",
        "Kementerian Keuangan": "KEMENKEU",
        "Kementerian Imigrasi dan Pemasyarakatan": "KEMENKUMHAM",
    };

    const getShortMinistry = () => {
        if (values.software !== "academic") {
            return "";
        }

        return ministryShortName[values.institution_ministry] || "";
    };

    return (
        <SectionForm
            icon={<AppWindow className="w-5 h-5" />}
            title="Wilayah"
            color="blue"
        >
            {["province", "city", "district"].includes(
                values.level_region
            ) && (
                    <RegionField
                        label="Provinsi"
                        name="province"
                        loading={loadingProvinces}
                        loadingText="Memuat provinsi..."
                        options={dataProvinces}
                        placeholder="Pilih Provinsi"
                        onChange={(value) => {
                            setProvince(value);
                            setDataCities([]);
                            setDataDistricts([]);

                            setFieldValue("city", "");
                            setFieldValue("district", "");
                            setFieldValue("institute_level", "");

                            if (values.level_region === "province" && values.software === "zone") {
                                setFieldValue(
                                    "corp_name",
                                    `PEMERINTAH PROVINSI ${value}`
                                );
                            } else if (values.level_region === "province" && values.software === "academic") {
                                setFieldValue("institute_level", "regional");
                                setFieldValue(
                                    "corp_name",
                                    `${getShortMinistry()} PROV. ${value}`
                                );                                
                            }
                        }}
                    />
                )}

            {["city", "district"].includes(values.level_region) && (
                <RegionField
                    label="Kota / Kabupaten"
                    name="city"
                    loading={loadingCities}
                    loadingText="Memuat kota/kabupaten..."
                    options={dataCities}
                    placeholder="Pilih Kota/Kabupaten"
                    onChange={(value) => {
                        setCity(value);
                        setDataDistricts([]);

                        setFieldValue("district", "");
                        setFieldValue("institute_level", "");

                        if (values.level_region === "city" && values.software === "zone") {
                            setFieldValue(
                                "corp_name",
                                `PEMERINTAH ${value}`
                            );
                        } else if (values.level_region === "city" && values.software === "academic") {
                            setFieldValue("institute_level", "regional");
                            setFieldValue(
                                "corp_name",
                                `${getShortMinistry()} ${value}`
                            );
                        }
                    }}
                />
            )}

            {values.level_region === "district" && (
                <RegionField
                    label="Kecamatan"
                    name="district"
                    loading={loadingDistricts}
                    loadingText="Memuat kecamatan..."
                    options={dataDistricts}
                    placeholder="Pilih Kecamatan"
                    onChange={(value) => {
                        setDistrict(value);

                        setFieldValue("institute_level", "regional");

                        setFieldValue(
                            "corp_name",
                            `KECAMATAN ${value}`
                        );
                    }}
                />
            )}
        </SectionForm>
    );
}